import {
  ApiResponse,
  EmployeeLeaveUsageReport,
  LeaveSummaryReport,
  MonthlyTrendReport,
  TeamLeaveUsageReport,
} from "@/types";
import { api } from "./client";

interface ReportParams {
  year: number;
  month?: number;
  teamId?: string;
  leaveType?: string;
  employeeId?: string;
}

const cleanParams = (params: ReportParams) => {
  const cleaned: Record<string, string> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "undefined") {
      cleaned[key] = value.toString();
    }
  });
  return cleaned;
};

export const reportsService = {
  getLeaveSummary: async (params: ReportParams) => {
    const query = new URLSearchParams(cleanParams(params)).toString();
    const response = await api.get<ApiResponse<LeaveSummaryReport>>(
      `reports/leave-summary?${query}`,
    );
    return response.responseBody.data || {};
  },

  getEmployeeLeaveUsage: async (params: ReportParams) => {
    const query = new URLSearchParams(cleanParams(params)).toString();
    const response = await api.get<ApiResponse<EmployeeLeaveUsageReport[]>>(
      `reports/employee-leave-usage?${query}`,
    );
    return response.responseBody.data || [];
  },

  getMonthlyTrends: async (params: ReportParams) => {
    const query = new URLSearchParams(cleanParams(params)).toString();
    const response = await api.get<ApiResponse<MonthlyTrendReport[]>>(
      `reports/monthly-trends?${query}`,
    );
    return response.responseBody.data || [];
  },

  getTeamLeaveUsage: async (params: ReportParams) => {
    const query = new URLSearchParams(cleanParams(params)).toString();
    const response = await api.get<ApiResponse<TeamLeaveUsageReport[]>>(
      `reports/team-leave-usage?${query}`,
    );
    return response.responseBody.data || [];
  },
};
